import { render } from "./FiltersShop.vue?vue&type=template&id=7b0de012&scoped=true"
import script from "./FiltersShop.vue?vue&type=script&lang=js"
export * from "./FiltersShop.vue?vue&type=script&lang=js"

import "./FiltersShop.vue?vue&type=style&index=0&id=7b0de012&lang=scss&scoped=true"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7b0de012"]])

export default __exports__